/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for ArchivageResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions } from "../models";

@Injectable({ providedIn: "root" })
export class ArchivageResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    archiveUtilisateur(idUtilisateur: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveUtilisateur(idUtilisateur: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveUtilisateur(idUtilisateur: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveUtilisateur(idUtilisateur: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveUtilisateur1(idUtilisateur: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveUtilisateur1(idUtilisateur: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveUtilisateur1(idUtilisateur: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveUtilisateur1(idUtilisateur: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveUtilisateur2(idUtilisateur: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveUtilisateur2(idUtilisateur: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveUtilisateur2(idUtilisateur: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveUtilisateur2(idUtilisateur: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveUtilisateur4(idUtilisateur: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveUtilisateur4(idUtilisateur: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveUtilisateur4(idUtilisateur: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveUtilisateur4(idUtilisateur: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveUtilisateur3(idUtilisateur: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveUtilisateur3(idUtilisateur: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveUtilisateur3(idUtilisateur: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveUtilisateur3(idUtilisateur: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveUtilisateur6(idUtilisateur: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveUtilisateur6(idUtilisateur: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveUtilisateur6(idUtilisateur: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveUtilisateur6(idUtilisateur: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveUtilisateur5(idUtilisateur: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveUtilisateur5(idUtilisateur: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveUtilisateur5(idUtilisateur: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveUtilisateur5(idUtilisateur: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-utilisateur`;

        let params = new HttpParams();
        if (idUtilisateur != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idUtilisateur, 'idUtilisateur');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveDiplome(idTypesDiplome: number, motifArchDiplome: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveDiplome(idTypesDiplome: number, motifArchDiplome: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveDiplome(idTypesDiplome: number, motifArchDiplome: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveDiplome(idTypesDiplome: number, motifArchDiplome: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-type-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }
        if (motifArchDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchDiplome, 'motifArchDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveDiplome1(idTypesDiplome: number, motifArchDiplome: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveDiplome1(idTypesDiplome: number, motifArchDiplome: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveDiplome1(idTypesDiplome: number, motifArchDiplome: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveDiplome1(idTypesDiplome: number, motifArchDiplome: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-type-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }
        if (motifArchDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchDiplome, 'motifArchDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveDiplome2(idTypesDiplome: number, motifArchDiplome: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveDiplome2(idTypesDiplome: number, motifArchDiplome: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveDiplome2(idTypesDiplome: number, motifArchDiplome: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveDiplome2(idTypesDiplome: number, motifArchDiplome: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-type-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }
        if (motifArchDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchDiplome, 'motifArchDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveDiplome4(idTypesDiplome: number, motifArchDiplome: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveDiplome4(idTypesDiplome: number, motifArchDiplome: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveDiplome4(idTypesDiplome: number, motifArchDiplome: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveDiplome4(idTypesDiplome: number, motifArchDiplome: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-type-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }
        if (motifArchDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchDiplome, 'motifArchDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveDiplome3(idTypesDiplome: number, motifArchDiplome: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveDiplome3(idTypesDiplome: number, motifArchDiplome: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveDiplome3(idTypesDiplome: number, motifArchDiplome: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveDiplome3(idTypesDiplome: number, motifArchDiplome: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-type-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }
        if (motifArchDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchDiplome, 'motifArchDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveDiplome6(idTypesDiplome: number, motifArchDiplome: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveDiplome6(idTypesDiplome: number, motifArchDiplome: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveDiplome6(idTypesDiplome: number, motifArchDiplome: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveDiplome6(idTypesDiplome: number, motifArchDiplome: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-type-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }
        if (motifArchDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchDiplome, 'motifArchDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveDiplome5(idTypesDiplome: number, motifArchDiplome: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveDiplome5(idTypesDiplome: number, motifArchDiplome: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveDiplome5(idTypesDiplome: number, motifArchDiplome: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveDiplome5(idTypesDiplome: number, motifArchDiplome: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-type-diplome`;

        let params = new HttpParams();
        if (idTypesDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTypesDiplome, 'idTypesDiplome');
        }
        if (motifArchDiplome != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchDiplome, 'motifArchDiplome');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveIes(idIes: number, motifArchIes: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveIes(idIes: number, motifArchIes: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveIes(idIes: number, motifArchIes: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveIes(idIes: number, motifArchIes: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-ies`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (motifArchIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchIes, 'motifArchIes');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveIes1(idIes: number, motifArchIes: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveIes1(idIes: number, motifArchIes: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveIes1(idIes: number, motifArchIes: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveIes1(idIes: number, motifArchIes: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-ies`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (motifArchIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchIes, 'motifArchIes');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveIes2(idIes: number, motifArchIes: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveIes2(idIes: number, motifArchIes: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveIes2(idIes: number, motifArchIes: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveIes2(idIes: number, motifArchIes: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-ies`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (motifArchIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchIes, 'motifArchIes');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveIes4(idIes: number, motifArchIes: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveIes4(idIes: number, motifArchIes: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveIes4(idIes: number, motifArchIes: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveIes4(idIes: number, motifArchIes: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-ies`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (motifArchIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchIes, 'motifArchIes');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveIes3(idIes: number, motifArchIes: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveIes3(idIes: number, motifArchIes: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveIes3(idIes: number, motifArchIes: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveIes3(idIes: number, motifArchIes: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-ies`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (motifArchIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchIes, 'motifArchIes');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveIes6(idIes: number, motifArchIes: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveIes6(idIes: number, motifArchIes: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveIes6(idIes: number, motifArchIes: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveIes6(idIes: number, motifArchIes: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-ies`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (motifArchIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchIes, 'motifArchIes');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveIes5(idIes: number, motifArchIes: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveIes5(idIes: number, motifArchIes: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveIes5(idIes: number, motifArchIes: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveIes5(idIes: number, motifArchIes: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-ies`;

        let params = new HttpParams();
        if (idIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idIes, 'idIes');
        }
        if (motifArchIes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchIes, 'motifArchIes');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveFormation1(idFormation: number, motifArchFormation: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveFormation1(idFormation: number, motifArchFormation: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveFormation1(idFormation: number, motifArchFormation: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveFormation1(idFormation: number, motifArchFormation: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-formation`;

        let params = new HttpParams();
        if (idFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idFormation, 'idFormation');
        }
        if (motifArchFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchFormation, 'motifArchFormation');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveFormation2(idFormation: number, motifArchFormation: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveFormation2(idFormation: number, motifArchFormation: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveFormation2(idFormation: number, motifArchFormation: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveFormation2(idFormation: number, motifArchFormation: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-formation`;

        let params = new HttpParams();
        if (idFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idFormation, 'idFormation');
        }
        if (motifArchFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchFormation, 'motifArchFormation');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveFormation3(idFormation: number, motifArchFormation: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveFormation3(idFormation: number, motifArchFormation: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveFormation3(idFormation: number, motifArchFormation: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveFormation3(idFormation: number, motifArchFormation: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-formation`;

        let params = new HttpParams();
        if (idFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idFormation, 'idFormation');
        }
        if (motifArchFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchFormation, 'motifArchFormation');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveFormation5(idFormation: number, motifArchFormation: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveFormation5(idFormation: number, motifArchFormation: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveFormation5(idFormation: number, motifArchFormation: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveFormation5(idFormation: number, motifArchFormation: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-formation`;

        let params = new HttpParams();
        if (idFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idFormation, 'idFormation');
        }
        if (motifArchFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchFormation, 'motifArchFormation');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveFormation4(idFormation: number, motifArchFormation: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveFormation4(idFormation: number, motifArchFormation: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveFormation4(idFormation: number, motifArchFormation: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveFormation4(idFormation: number, motifArchFormation: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-formation`;

        let params = new HttpParams();
        if (idFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idFormation, 'idFormation');
        }
        if (motifArchFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchFormation, 'motifArchFormation');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveFormation7(idFormation: number, motifArchFormation: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveFormation7(idFormation: number, motifArchFormation: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveFormation7(idFormation: number, motifArchFormation: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveFormation7(idFormation: number, motifArchFormation: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-formation`;

        let params = new HttpParams();
        if (idFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idFormation, 'idFormation');
        }
        if (motifArchFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchFormation, 'motifArchFormation');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveFormation6(idFormation: number, motifArchFormation: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveFormation6(idFormation: number, motifArchFormation: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveFormation6(idFormation: number, motifArchFormation: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveFormation6(idFormation: number, motifArchFormation: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-formation`;

        let params = new HttpParams();
        if (idFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idFormation, 'idFormation');
        }
        if (motifArchFormation != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchFormation, 'motifArchFormation');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveEtablissement(idEtablissement: number, motifArchEtablissement: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveEtablissement(idEtablissement: number, motifArchEtablissement: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveEtablissement(idEtablissement: number, motifArchEtablissement: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveEtablissement(idEtablissement: number, motifArchEtablissement: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (motifArchEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchEtablissement, 'motifArchEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveEtablissement1(idEtablissement: number, motifArchEtablissement: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveEtablissement1(idEtablissement: number, motifArchEtablissement: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveEtablissement1(idEtablissement: number, motifArchEtablissement: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveEtablissement1(idEtablissement: number, motifArchEtablissement: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (motifArchEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchEtablissement, 'motifArchEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveEtablissement2(idEtablissement: number, motifArchEtablissement: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveEtablissement2(idEtablissement: number, motifArchEtablissement: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveEtablissement2(idEtablissement: number, motifArchEtablissement: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveEtablissement2(idEtablissement: number, motifArchEtablissement: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (motifArchEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchEtablissement, 'motifArchEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveEtablissement4(idEtablissement: number, motifArchEtablissement: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveEtablissement4(idEtablissement: number, motifArchEtablissement: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveEtablissement4(idEtablissement: number, motifArchEtablissement: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveEtablissement4(idEtablissement: number, motifArchEtablissement: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (motifArchEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchEtablissement, 'motifArchEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveEtablissement3(idEtablissement: number, motifArchEtablissement: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveEtablissement3(idEtablissement: number, motifArchEtablissement: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveEtablissement3(idEtablissement: number, motifArchEtablissement: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveEtablissement3(idEtablissement: number, motifArchEtablissement: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (motifArchEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchEtablissement, 'motifArchEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveEtablissement6(idEtablissement: number, motifArchEtablissement: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveEtablissement6(idEtablissement: number, motifArchEtablissement: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveEtablissement6(idEtablissement: number, motifArchEtablissement: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveEtablissement6(idEtablissement: number, motifArchEtablissement: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (motifArchEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchEtablissement, 'motifArchEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveEtablissement5(idEtablissement: number, motifArchEtablissement: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveEtablissement5(idEtablissement: number, motifArchEtablissement: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveEtablissement5(idEtablissement: number, motifArchEtablissement: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveEtablissement5(idEtablissement: number, motifArchEtablissement: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-etablissement`;

        let params = new HttpParams();
        if (idEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idEtablissement, 'idEtablissement');
        }
        if (motifArchEtablissement != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchEtablissement, 'motifArchEtablissement');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveDomaine(idDomaine: number, motifArchDomaine: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveDomaine(idDomaine: number, motifArchDomaine: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveDomaine(idDomaine: number, motifArchDomaine: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveDomaine(idDomaine: number, motifArchDomaine: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-domaine`;

        let params = new HttpParams();
        if (idDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idDomaine, 'idDomaine');
        }
        if (motifArchDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchDomaine, 'motifArchDomaine');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveDomaine1(idDomaine: number, motifArchDomaine: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveDomaine1(idDomaine: number, motifArchDomaine: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveDomaine1(idDomaine: number, motifArchDomaine: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveDomaine1(idDomaine: number, motifArchDomaine: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-domaine`;

        let params = new HttpParams();
        if (idDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idDomaine, 'idDomaine');
        }
        if (motifArchDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchDomaine, 'motifArchDomaine');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveDomaine2(idDomaine: number, motifArchDomaine: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveDomaine2(idDomaine: number, motifArchDomaine: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveDomaine2(idDomaine: number, motifArchDomaine: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveDomaine2(idDomaine: number, motifArchDomaine: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-domaine`;

        let params = new HttpParams();
        if (idDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idDomaine, 'idDomaine');
        }
        if (motifArchDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchDomaine, 'motifArchDomaine');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveDomaine4(idDomaine: number, motifArchDomaine: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveDomaine4(idDomaine: number, motifArchDomaine: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveDomaine4(idDomaine: number, motifArchDomaine: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveDomaine4(idDomaine: number, motifArchDomaine: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-domaine`;

        let params = new HttpParams();
        if (idDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idDomaine, 'idDomaine');
        }
        if (motifArchDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchDomaine, 'motifArchDomaine');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveDomaine3(idDomaine: number, motifArchDomaine: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveDomaine3(idDomaine: number, motifArchDomaine: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveDomaine3(idDomaine: number, motifArchDomaine: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveDomaine3(idDomaine: number, motifArchDomaine: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-domaine`;

        let params = new HttpParams();
        if (idDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idDomaine, 'idDomaine');
        }
        if (motifArchDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchDomaine, 'motifArchDomaine');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveDomaine6(idDomaine: number, motifArchDomaine: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveDomaine6(idDomaine: number, motifArchDomaine: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveDomaine6(idDomaine: number, motifArchDomaine: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveDomaine6(idDomaine: number, motifArchDomaine: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-domaine`;

        let params = new HttpParams();
        if (idDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idDomaine, 'idDomaine');
        }
        if (motifArchDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchDomaine, 'motifArchDomaine');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    archiveDomaine5(idDomaine: number, motifArchDomaine: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<boolean>;
    archiveDomaine5(idDomaine: number, motifArchDomaine: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<boolean>>;
    archiveDomaine5(idDomaine: number, motifArchDomaine: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<boolean>>;
    archiveDomaine5(idDomaine: number, motifArchDomaine: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/archive-domaine`;

        let params = new HttpParams();
        if (idDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idDomaine, 'idDomaine');
        }
        if (motifArchDomaine != null) {
            params = HttpParamsBuilder.addToHttpParams(params, motifArchDomaine, 'motifArchDomaine');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
